import { useMemo } from "react";
import { ScrollText } from "lucide-react";
import { SAMPLE_TX } from "../data/mock";
const ACTIONS = ["Giriş yapıldı", "Yatırım onaylandı", "Çekim reddedildi", "Ayar güncellendi", "Kullanıcı eklendi", "Bonus tanımlandı", "IBAN değiştirildi", "Çekim onaylandı"];
const USERS = ["sezar.admin", "finans1", "saha.sorumlu", "destek3", "izleyici2"];
const IPS = ["88.243.12.4", "78.190.55.201", "195.174.9.33", "94.55.201.7", "31.223.88.19"];

export default function Loglar() {
  const logs = useMemo(() => {
    return SAMPLE_TX.slice(0, 40).map((t, i) => ({
      id: t.id,
      user: USERS[i % USERS.length],
      action: ACTIONS[i % ACTIONS.length],
      ip: IPS[i % IPS.length],
      date: t.dateStr,
    }));
  }, []);

  return (
    <div className="space-y-5" data-testid="page-loglar">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
          <ScrollText className="text-[#F0651E]" size={22} />
        </div>
        <div>
          <h1 className="text-xl font-extrabold">Sistem Logları</h1>
          <p className="text-xs text-slate-500">Yönetici işlem kayıtları</p>
        </div>
      </div>

      <div className="bg-white dark:bg-[#151824] rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[13px] font-bold text-violet-600 dark:text-violet-400 border-b border-slate-100 dark:border-slate-800">
                <th className="px-6 py-3">KULLANICI</th>
                <th className="px-4 py-3">İŞLEM</th>
                <th className="px-4 py-3">IP ADRESİ</th>
                <th className="px-6 py-3 text-right">TARİH</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
              {logs.map((l) => (
                <tr key={l.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50">
                  <td className="px-6 py-3 font-bold text-slate-700 dark:text-slate-200">{l.user}</td>
                  <td className="px-4 py-3">{l.action}</td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-500">{l.ip}</td>
                  <td className="px-6 py-3 text-right text-slate-500 whitespace-nowrap">{l.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
